module.exports = __webpack_public_path__ + "static/damm-673a24d257be4b4d903175966f1817f0.gif";